import React, { memo } from 'react';
import { useBulletinResponse } from '../../context/bulletin';

const ReviewProgression = ({
  userIsAuthenticated,
}: {
  userIsAuthenticated: boolean;
}) => {
  const bulletinResponse = useBulletinResponse();

  const bulletinPercentageValidation = bulletinResponse.progress_percent;

  if (!userIsAuthenticated || bulletinPercentageValidation === undefined) {
    return null;
  }

  const seensItemsAsPercentage = Math.round(bulletinPercentageValidation);

  return (
    <div className="reviewProgression">
      <div>Progression: {seensItemsAsPercentage}%</div>
      <progress max="100" value={seensItemsAsPercentage} />
    </div>
  );
};

export default memo(ReviewProgression);
